<app-loading-guard [loading]="loading">
  <mat-card appearance="outlined" class="subscribe-card">
    <strong>Subscribe now</strong>: Choose a plan to get started. You
    can always change it later.
  </mat-card>
  <app-subscription-create></app-subscription-create>
</app-loading-guard>
